import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { Fragment, useMemo, useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { R50, R500 } from '@atlaskit/theme/colors';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { dropdownItemGroupStyles, contentStyles, linkStyles, textStyles } from './styled';
import { getFormattedMessage, openEmbedModalWithFlexibleUiIcon } from '../../../../utils';
import { messages } from '../../../../../../../messages';
import { useFlexibleUiAnalyticsContext } from '../../../../../../../state/flexible-ui-context';
import useResolve from '../../../../../../../state/hooks/use-resolve';
var MAX_LINE_NUMBER = 8;
var LozengeActionError = function LozengeActionError(_ref) {
  var errorMessage = _ref.errorMessage,
    testId = _ref.testId,
    _ref$maxLineNumber = _ref.maxLineNumber,
    maxLineNumber = _ref$maxLineNumber === void 0 ? MAX_LINE_NUMBER : _ref$maxLineNumber,
    url = _ref.url,
    previewData = _ref.previewData;
  var reload = useResolve();
  var analytics = useFlexibleUiAnalyticsContext();
  var isPreviewAvailable = previewData && previewData.src !== undefined;
  var handlePreviewClose = useCallback(function () {
    if (url) {
      reload(url, true);
    }
  }, [reload, url]);
  var handlePreviewOpen = useCallback(function () {
    if (isPreviewAvailable) {
      analytics === null || analytics === void 0 || analytics.ui.smartLinkLozengeActionErrorOpenPreviewClickedEvent();
      return openEmbedModalWithFlexibleUiIcon(_objectSpread(_objectSpread({}, previewData), {}, {
        analytics: analytics,
        onClose: handlePreviewClose
      }));
    }
  }, [analytics, handlePreviewClose, isPreviewAvailable, previewData]);
  var content = useMemo(function () {
    return jsx(Fragment, null, jsx("div", {
      css: contentStyles
    }, jsx(ErrorIcon, {
      testId: "".concat(testId, "-icon"),
      LEGACY_size: "medium",
      color: "var(--ds-icon-danger, ".concat(R500, ")"),
      LEGACY_secondaryColor: "var(--ds-background-danger, ".concat(R50, ")"),
      label: 'error',
      spacing: "spacious"
    }), jsx("span", {
      css: textStyles(maxLineNumber),
      "data-testid": "".concat(testId, "-error-message")
    }, typeof errorMessage === 'string' ? errorMessage : getFormattedMessage(errorMessage))), isPreviewAvailable ?
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("div", {
      css: linkStyles
    }, jsx("a", {
      target: "_blank",
      "data-testid": "".concat(testId, "-open-embed"),
      onClick: handlePreviewOpen
    }, jsx(FormattedMessage, messages.open_issue_in_jira))) : null);
  }, [errorMessage, handlePreviewOpen, isPreviewAvailable, maxLineNumber, testId]);
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("span", {
      css: dropdownItemGroupStyles,
      "data-testid": "".concat(testId, "-error-item-group")
    }, jsx(DropdownItemGroup, null, jsx(DropdownItem, {
      testId: "".concat(testId, "-error")
    }, content)))
  );
};
export default LozengeActionError;